import React from 'react'
// import { TNextCheckAt } from '../../types/feed'
import Select from '@hilbi/web-common/components/select'
import { t } from 'i18next'
import { SelectCheckSC } from './select-next-check.styled'
import { TActionType } from '../../reducers/addRecordReducer'
// import { add, formatISO } from 'date-fns'

interface ISelectNextCheckProps {
  dispatch: React.Dispatch<TActionType>
  dropdownValue: string | null
}

const SelectNextCheck: React.FC<ISelectNextCheckProps> = ({ dispatch, dropdownValue }) => {
  const handleSelectChange = (e: { value: string; label: string }) => {
    dispatch({ type: 'ADD_RECORD_CHECKUP_CHANGE', payload: e.value })
  }

  const options = [
    { value: '1w', label: t('nextCheck.in1Week') },
    { value: '2w', label: t('nextCheck.in2Weeks') },
    { value: '1m', label: t('nextCheck.in1Month') },
    { value: '2m', label: t('nextCheck.in2Months') },
    { value: '3m', label: t('nextCheck.in3Months') },
    { value: '6m', label: t('nextCheck.in6Months') },
  ]

  return (
    <>
      <SelectCheckSC>
        <Select
          value={options.filter((option) => option.value === dropdownValue)}
          options={options}
          variation='underline'
          multi={false}
          onChange={handleSelectChange}
          placeholder={t('addRecord.nextCheck')}
          id='next-check'
        />
      </SelectCheckSC>
    </>
  )
}
export default SelectNextCheck
